import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

export default function AdvancedBlocks() {
    const [buttonText, setButtonText] = useState("Copy Code");

    const handleCopyClick = async (codeId: string) => {
        const codeElement = document.getElementById(codeId);
        const buttonElement = document.getElementById(`copyButton_${codeId}`);

        if (codeElement && buttonElement) {
            const codeText = codeElement.innerText;
            try {
                await navigator.clipboard.writeText(codeText);
                setButtonText("Copied");
                setTimeout(() => {
                    setButtonText("Copy Code");
                }, 2000);
            } catch (err) {
                console.error("Unable to copy to clipboard", err);
            }
        }
    };

    return (
        <section className="container flex flex-col">
            <div className="flex flex-col my-2 space-y-2">
                <div className="flex flex-col w-full ">
                    <h2 className="text-lg py-2 text font-semibold">
                        Testimonial Slider
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>

                        <TabsContent value="example" className="p-8 w-10/12">
                            <img 
                                loading="eager" 
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/testimonials/furniture-bedding-testimonial-raywhite-staging.jpg`} 
                                alt="Ray White Staged house" 
                                className="absolute inset-0 w-full lg:h-full h-[306px] object-cover" 
                            />
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex items-end w-full justify-end px-6">
                                <button
                                    id="copyButton_code1"
                                    onClick={() => handleCopyClick("code1")}
                                    className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                                >
                                    {buttonText}
                                </button>
                            </div>
                            <div className="flex flex-col items-center px-6 whitespace-pre-line">                                
                                <code id="code1" className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                
                                        <style>
                                            .testimonial-slide {
                                             transition: transform 1s ease-in-out;
                                             }
    
                                            .testimonial-dot {
                                            width: 12px;
                                            height: 12px;
                                            background-color: rgba(107, 114, 128, 0.7);
                                            border-radius: 50%;
                                            margin: 0 4px;
                                            cursor: pointer;
                                            }
    
                                            .testimonial-dot.active {
                                            background-color: #cb1829;
                                            }
    

                                        </style>
                                        <div class="bg-white w-full pt-12 pb-20">
                                        <h1 class="text-2xl font-semibold text-black text-center pb-16">What our clients have to say</h1>
                                        <div class="mx-auto px-8 xl:px-0 xl:max-w-[72%]">
                                            <div class="relative rounded block md:flex items-center bg-harvey-black" style="min-height: 19rem;">
                                                <div class="relative w-full md:w-3/5 overflow-hidden" style="min-height: 19rem;">
                                                    <div id="slidesContainer">
                                                        <!-- Slide 1 -->
                                                        <div class="testimonial-slide">
                                                            <img loading="eager" src="https://hncnzwww.blob.core.windows.net/www/img/testimonials/furniture-bedding-testimonial-raywhite-staging.jpg" alt="Ray White Staged house" class="absolute inset-0 w-full lg:h-full h-[306px] object-cover">
                                                        </div>
                                                        {/* Slide 2 */}
                                                        <div class="testimonial-slide hidden">
                                                            <img 
                                                                loading="eager" 
                                                                src="https://hncnzwww.blob.core.windows.net/www/img/products/furniture-bedding-testimonials-classic-builders.jpg" 
                                                                alt="Classic Builders Furnished house" 
                                                                className="absolute inset-0 w-full lg:h-full h-[306px] object-cover" 
                                                            />
                                                        </div>
                                                        {/* Slide 3 */}
                                                        <div class="testimonial-slide hidden">
                                                            <img 
                                                                loading="eager" 
                                                                src="https://hncnzwww.blob.core.windows.net/www/img/products/furniture-bedding-testimonials-kerepeti.jpg" 
                                                                alt="Kerepeti Staged House" 
                                                                className="absolute inset-0 w-full lg:h-full h-[306px] object-cover" 
                                                            />
                                                        </div>
                                                        {/* Slide 4 */}
                                                        <div class="testimonial-slide hidden">
                                                            <img 
                                                                loading="eager" 
                                                                src="https://hncnzwww.blob.core.windows.net/www/img/products/furniture-bedding-testimonials-pacifica.jpg" 
                                                                alt="Pacifica Apartments Show Home" 
                                                                className="absolute inset-0 w-full lg:h-full h-[306px] object-cover" 
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="w-full md:w-3/5 flex items-center bg-transparent rounded">
                                                    <div class="md:pl-4 lg:pl-12">
                                                        <div id="contentContainer">
                                                            {/* Content 1 */}
                                                            <div class="testimonial-content-container">
                                                                <div class="lg:absolute top-4 left-66 z-10 text-white p-4 md:p-0">
                                                                    <h1 class="xl:text-2xl text-lg font-semibold xl:mt-4">Ray White</h1>
                                                                    <p class="text-lg font-semibold text-harvey-red">Alyssa Cullen</p>
                                                                    <p class="text-gray-400 mb-2 lg:mb-4">Real Estate Agent</p>
                                                                    <p class="text-white xl:max-w-xl font-extralight lg:mb-4 md:pr-6 lg:pr-4 xl:pr-0 line-clamp-4">"I used Harvey Norman Commercial to stage two large homes in Pt Chevalier, both with slightly differing aesthetics. Volli and her team listened to my needs, were super friendly and helpful. I loved their staging so much I ended up buying the dining table, chairs and lounge suite!! Would highly recommend."</p>
                                                                    <a href="/resources/blogs/23db5358-b571-eb11-a812-000d3acbab5d/" target="_blank" class="underline text-harvey-red underline-offset-4 py-2">Read more</a>
                                                                </div>
                                                            </div>
                                                            {/* Content 2 */}
                                                            <div class="testimonial-content-container hidden">
                                                                <div class="lg:absolute top-4 left-66 z-10 text-white p-4 md:p-0">
                                                                    <h1 class="xl:text-2xl text-lg font-semibold xl:mt-4">Classic Builders</h1>
                                                                    <p class="text-lg font-semibold text-harvey-red">David Fahey</p>
                                                                    <p class="text-gray-400 mb-2 lg:mb-4">Building Consultant</p>
                                                                    <p class="text-white xl:max-w-xl font-extralight lg:mb-4 md:pr-6 lg:pr-4 xl:pr-0 line-clamp-4">"The team at Harvey Norman provided an expert staging solution for our recent showhome. The product selection was great and the team worked with us to find solutions that enhanced the space and exceeded expectation. A great one stop shop."</p>
                                                                    <a href="/resources/blogs/7a1b3e6c-5872-eb11-a812-000d3acba96b/" target="_blank" class="underline text-harvey-red underline-offset-4 py-2">Read more</a>
                                                                </div>
                                                            </div>
                                                            {/* Content 3 */}
                                                            <div class="testimonial-content-container hidden">
                                                                <div class="lg:absolute top-4 left-66 z-10 text-white p-4 md:p-0">
                                                                    <h1 class="xl:text-2xl text-lg font-semibold xl:mt-4">Founders Land Developers</h1>
                                                                    <p class="text-lg font-semibold text-harvey-red">Jennifer Yung</p>
                                                                    <p class="text-gray-400 mb-2 lg:mb-4">Sales & Project Coordinator</p>
                                                                    <p class="text-white xl:max-w-xl font-extralight lg:mb-4 md:pr-6 lg:pr-4 xl:pr-0 line-clamp-4">"We have found Harvey Norman Commercial team professional and punctual and the staging and advice you gave were excellent. We have received excellent feedback from potential purchasers about the colour scheme and natural look of your furniture as well as the good value! I highly recommend staging homes in order to sell efficiently and effectively."</p>
                                                                </div>
                                                            </div>
                                                            {/* Content 4 */}
                                                            <div class="testimonial-content-container hidden">
                                                                <div class="lg:absolute top-4 left-66 z-10 text-white p-4 md:p-0">
                                                                    <h1 class="xl:text-2xl text-lg font-semibold xl:mt-4">Pacifica Apartments</h1>
                                                                    <p class="text-lg font-semibold text-harvey-red">Gary & Melanie Swanson</p>
                                                                    <p class="text-gray-400 mb-2 lg:mb-4">Owners</p>
                                                                    <p class="text-white xl:max-w-xl font-extralight lg:mb-4 md:pr-6 lg:pr-4 xl:pr-0 line-clamp-4">"It’s the people, the consistency of supply, the cost-effective and high quality product range, and the after service care. They get the job done."</p>
                                                                    <a href="/resources/blogs/311d2f9f-5872-eb11-a812-000d3acba96b/" target="_blank" class="underline text-harvey-red underline-offset-4 py-2">Read more</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <svg class="hidden lg:block absolute inset-y-0 h-full w-24 fill-current text-black -ml-12" viewBox="0 0 100 100" fill="currentColor" preserveAspectRatio="none slice">
                                                        <path d="M50 0H100L50 100H0L50 0Z" style="fill: #1E1E1E;"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="flex items-center justify-center mt-8">
                                                <div id="dotsContainer" class="flex">
                                                    <span class="testimonial-dot active"></span>
                                                    <span class="testimonial-dot"></span>
                                                    <span class="testimonial-dot"></span>
                                                    <span class="testimonial-dot"></span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <script>
                                        // Wait for DOM to be ready
                                        document.addEventListener('DOMContentLoaded', function() {
                                            // Use 'let' instead of 'const' to avoid redeclaration issues
                                            let slides = document.querySelectorAll('.testimonial-slide');
                                            const contents = document.querySelectorAll('.testimonial-content-container');
                                            const dots = document.querySelectorAll('.testimonial-dot');
                                            
                                            // Safety check
                                            if (slides.length === 0 || contents.length === 0 || dots.length === 0) {
                                                console.warn('Testimonial elements not found');
                                                return;
                                            }
                                            
                                            let currentSlide = 0;
                                            const slideInterval = 5000; // 5 seconds
                                        
                                        function showSlide(index) {
                                            console.debug("Show Slide")
                                            slides.forEach((slide, i) => {
                                                slide.classList.toggle('hidden', i !== index);
                                            });
                                            contents.forEach((content, i) => {
                                                content.classList.toggle('hidden', i !== index);
                                            });
                                            dots.forEach((dot, i) => {
                                                dot.classList.toggle('active', i === index);
                                            });
                                        }
                                        
                                        function nextSlide() {
                                            currentSlide = (currentSlide + 1) % slides.length;
                                            showSlide(currentSlide);
                                        }
                                        
                                        dots.forEach((dot, index) => {
                                            dot.addEventListener('click', () => {
                                                currentSlide = index;
                                                showSlide(currentSlide);
                                                clearInterval(autoSlideInterval);
                                                autoSlideInterval = setInterval(nextSlide, slideInterval);
                                            });
                                        });
                                        
                                        let autoSlideInterval = setInterval(nextSlide, slideInterval);
                                        
                                        // Initialize
                                        showSlide(currentSlide);
                                        }); // End DOMContentLoaded
                                        </script>


                               `}
                                </code>

                            </div>
                        </TabsContent>
                    </Tabs>

                </div>
            </div>
            <div className="flex flex-col my-2 space-y-2">
                <div className="flex flex-col w-full ">
                    <h2 className="text-lg py-2 text font-semibold">
                        Brands Slider
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>

                        <TabsContent value="example" className="p-8 w-10/12">
                            <img 
                                src="https://hncnzwww.blob.core.windows.net/www/img/NewWebPhotos/DesignElements/slider.png" 
                                alt="heroImage" 
                            />
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex items-end w-full justify-end px-6">
                                <button
                                    id="copyButton_code2"
                                    onClick={() => handleCopyClick("code2")}
                                    className="my-4 py-2 px-4 bg-harvey-red text-white rounded-md hover:bg-harvey-red/80"
                                >
                                    {buttonText}
                                </button>
                            </div>
                            <div className="flex flex-col items-center px-6 whitespace-pre-line">

                                <code id="code2" className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                      <section class="snap-center">
                                      <div class="flex items-center bg-black">
                                          <div class="flex justify-evenly items-center bg-white py-16 w-[100%] my-8 overflow-hidden ">
                                              <div class="brand-container flex items-center w-[100%] overflow-hidden justify-evenly transition-transform duration-500 ease-in-out">
                                                  <!-- Slide 1 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-fujitsu-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 2 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center " src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-mitsubishi-electric-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 3 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-schweigen-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 4 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-sirius-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 5 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-rinnai-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 6 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-panasonic-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 7 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-lg-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 8 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-toshiba-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 9 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-bosch-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 10 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-zenith-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 11 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-vintec-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 12 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-ilve-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 13 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-ariston-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 14 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center " src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-insinkerator-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 15 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center " src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-panasonic-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 16 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-belling-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 17 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center  " src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-westinghouse-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 18 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center " src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-dyson-logo.png" alt="">
                                                  </div>
                                                  <!-- Slide 20 -->
                                                  <div class="brand">
                                                      <img class="w-full h-full object-cover object-center" src="https://cdn01.harveynormancommercial.nz/www/img/sector/design-architecture-samsung-logo.png" alt="">
                                                  </div>
                                              </div>
                                          </div>
                                          <!-- Carousel Body -->
                                      </div>
                                  </section>
                                  <script>
                                      // Wait for DOM to be ready
                                      document.addEventListener('DOMContentLoaded', function() {
                                          // Use 'let' instead of 'const' to avoid redeclaration issues
                                          let brandElements = document.querySelectorAll('.brand');
                                          
                                          // Safety check
                                          if (brandElements.length === 0) {
                                              console.warn('Brand elements not found');
                                              return;
                                          }
                                          
                                          // Extract logo data from elements with the "brand" class
                                          const rotatingLogos = Array.from(brandElements).map((brandElement) => {
                                              const imgElement = brandElement.querySelector('img');
                                              if (!imgElement) {
                                                  console.warn('Brand element missing img tag');
                                                  return null;
                                              }
                                              return {
                                                  src: imgElement.src,
                                                  alt: imgElement.alt,
                                              };
                                          }).filter(Boolean); // Remove null entries

                                      let visibleLogos = rotatingLogos.slice(0);
                                      let currentIndex = 0;

                                      // Set up an interval to change logos every 3 seconds
                                      const interval = setInterval(() => {
                                          currentIndex = (currentIndex + 1) % rotatingLogos.length;
                                          updateVisibleLogos();
                                      }, 2000);

                                      // Function to update the visible logos based on the current index
                                      function updateVisibleLogos() {
                                          let visibleIndices;

                                          if (window.innerWidth < 400) {
                                              // Show only one logo in very small views (e.g., mobile portrait)
                                              visibleIndices = [currentIndex];
                                          } else if (window.innerWidth < 900) {
                                              // Show a few logos in small views (e.g., mobile landscape or tablet)
                                              visibleIndices = [
                                                  currentIndex,
                                                  (currentIndex + 1) % rotatingLogos.length,
                                                  (currentIndex + 2) % rotatingLogos.length,
                                              ];
                                          } else {
                                              // Show multiple logos in larger views
                                              visibleIndices = [
                                                  currentIndex,
                                                  (currentIndex + 1) % rotatingLogos.length,
                                                  (currentIndex + 2) % rotatingLogos.length,
                                                  (currentIndex + 3) % rotatingLogos.length,
                                                  (currentIndex + 4) % rotatingLogos.length,
                                              ];
                                          }

                                          const logosToShow = visibleIndices.map((index) => rotatingLogos[index]);
                                          visibleLogos = logosToShow;
                                          // Only call displayVisibleLogos if it exists and is callable
                                          if (typeof displayVisibleLogos === 'function') {
                                              displayVisibleLogos();
                                          }
                                      }

                                      function displayVisibleLogos() {
                                          const brandContainer = document.querySelector('.brand-container');
                                          if (!brandContainer) return; // Safety check
                                          
                                          brandContainer.innerHTML = ''; // Clear the container

                                          visibleLogos.forEach((logoData) => {
                                              const logoElement = document.createElement('div');
                                              logoElement.className = 'brand';
                                              const logoImage = document.createElement('img');
                                              logoImage.src = logoData.src;
                                              logoImage.alt = logoData.alt;
                                              logoImage.classList.add('object-cover','h-12','w-full', 'object-center','transition-all','transition-opacity', 'duration-800', 'ease-in', 'transform','infinite');
                                              logoElement.appendChild(logoImage);
                                              // Append the logo element to the brand container
                                              brandContainer.appendChild(logoElement);
                                          });
                                      }

                                      // Call the updateVisibleLogos function initially
                                      updateVisibleLogos();
                                      }); // End DOMContentLoaded
                                  </script>
                            `}
                                </code>

                            </div>
                        </TabsContent>
                    </Tabs>

                </div>
            </div>
        </section>
    )
}